//3rd Party Components
import React, { Fragment } from 'react';
import { AUcallout } from '@gov.au/callout';
import { useSelector } from "react-redux";
import { Link } from "react-router-dom";

//Components
import Heading from '../components/CASA/Heading';

//Actions
import { getUserHomePage, UserMustSubmitIndividualARNApplication } from '../components/Portal/Utilities';
import { getUrlSelector, getSnippetSelector } from '../PortalStore/Selectors/EnvDataSelectors';
import moment from 'moment';

export const LinkARNPage = () => {

    let userdetails = useSelector(state => state.userdetails);
    let standalone = useSelector(state => state.B2CSettings.items.standalone);
    let loginPath = useSelector(state => state.B2CSettings.items.loginPath);
    let myGovUser = useSelector(state => state.B2CSettings.items.myGovUser);
    let participants = useSelector(state => state.participants);
    let srarnsIndividual = useSelector(state => state.srarnsIndividual);
    let tagsIndividual = useSelector(state => state.tagsIndividual);
    let acceptedSRsIndividual = useSelector(state => state.acceptedSRsIndividual);
    let certificatesIndividual = useSelector(state => state.certificatesIndividual);
    let draftarnsIndividual = useSelector(state => state.draftArnsIndividual);

    let snippetPOI = useSelector(state => getSnippetSelector(state, "CASA - POI"));

    let urlAEM = useSelector(state => getUrlSelector(state, "Portal - AEM URL"));
    let urlLinkARN = useSelector(state => getUrlSelector(state, "Portal - AEM LinkARN URL"));
    let urlAddARN = useSelector(state => getUrlSelector(state, "Portal - AEM AddARN URL"));

    const navigateAdd = (userHomePage) => {
        var crumbs = [
            {
                link: userHomePage + "/",
                text: 'myCASA'
            },
            {
                link: "/linkarn",
                text: 'Aviation reference number application'
            }
        ];
        var params = {
            'formID': 'ARN',
            'breadcrumbs': crumbs
        };

        if (participants.hasParticipants) {
            params.showProfileSelector = 1;
        }
        let addnav = urlAEM + urlAddARN + "?" + encodeURIComponent(btoa(JSON.stringify(params)));

        return addnav;
    }

    const navigateLink = (userHomePage) => {
        var crumbs = [
            {
                link: userHomePage + "/",
                text: 'myCASA'
            },
            {
                link: "/linkarn",
                text: 'Link aviation reference number application'
            }
        ];
        var params = {
            'formID': 'ARN',
            'breadcrumbs': crumbs
        };

        if (participants.hasParticipants) {
            params.showProfileSelector = 1;
        }
        let linknav = urlAEM + urlLinkARN + "?" + encodeURIComponent(btoa(JSON.stringify(params)));

        return linknav;
    }

    const poiMsg = () => {
        var msg = { __html: snippetPOI };
        if (loginPath === 'myGov') {
            let dateOfBirth = moment(myGovUser.dateOfBirth, 'YYYY-M-D', true)
            return (
            <div>
                <strong>Legal given names:</strong> {myGovUser.given_name}<br />
                <strong>Legal family name:</strong> {myGovUser.family_name}<br />
                <strong>Date of birth:</strong> {dateOfBirth.format('DD MMM YYYY')}<br />
                <strong>Email:</strong> {myGovUser.emails[0]}<br />
                <p>To complete your myCASA account and access myCASA services you will need to either apply for an <strong>aviation reference number</strong> (<abbr title="aviation reference number">ARN</abbr>) or link your existing <strong>aviation reference number</strong> (<abbr title="aviation reference number">ARN</abbr>).</p>
            </div>)
        }
        return (<div dangerouslySetInnerHTML={msg}></div>)
    }

    const showARN = () => {
        if (!userdetails ? false : !userdetails.items ? false : !userdetails.items.value ? false : userdetails.items.value.length === 0 ? false : userdetails.items.value[0].casa_arn === "" || userdetails.items.value[0].casa_arn === null) {
            const arnRoute = loginPath == 'myGov' ? '/arn/new' : '/arn-dvs/new';
            return (<Fragment><h2 id="addhdr">Need an ARN?</h2>
                <b>
                    <Link to={arnRoute} className="au-cta-link">Apply for aviation reference number (ARN)</Link>
                </b></Fragment>)
        }

    }

    // prevent access if user has arn or has applied for one
    let userHomePage = getUserHomePage(srarnsIndividual, draftarnsIndividual, userdetails, tagsIndividual, acceptedSRsIndividual, participants);
    if (!UserMustSubmitIndividualARNApplication(userHomePage)) {
        window.location.assign("/portal/error?code=LNK.1&standalone=" + standalone);
        return null;
    }
    else {
        let items = [];
        let showItems = false;
        const arnLinkRoute = loginPath == 'myGov' ? '/arn/link' : '/arn-dvs/link';
        return (
            <Fragment>
                <div className="row">
                    <div className="col-sm-12">
                        <Heading
                            text="Aviation Reference Number"
                            breadcrumbs={items}
                            showcrumbs={showItems}
                            showback={false} />
                    </div>
                </div>
                <AUcallout title="">
                    {poiMsg()}
                </AUcallout>
                {showARN()}
                <h2 id="linkhdr">Already have an ARN?</h2>
                <b>              
                    <Link to={arnLinkRoute} className="au-cta-link">Link existing aviation reference number (ARN)</Link>
                </b>
                <br />
            </Fragment>
        );
    }
}
